export const CONTRACTS_DETAILS_TYPES = Object.freeze({
  requests: 'requests',
  signed: 'signed',
  archived: 'archived'
})



// WEBPACK FOOTER //
// ./src/js/const/contracts.const.js